export const getPattern = state => state.editor.userInput.pattern;
